import { mutatorAction } from 'satcheljs';
import { getNotificationSettingsStore } from '../store/store';

export const setIsNotificationSettingsDirty = mutatorAction(
    'SET_ISNOTIFICATION_SETTINGS_DIRTY',
    (dirtyState: boolean) => {
        getNotificationSettingsStore().desktopNotificationSettingsDirty = dirtyState;
    }
);
